import PropTypes from 'prop-types';
import React from 'react';
import {ToggleButton} from '@social-native/snclient-ui';
import '@social-native/snclient-ui/dist/style.css';

import {ENUMS} from 'js/common';

const {ContentType} = ENUMS;

const ContentTypeSelector = ({changeContentType, currentContentType}) => (
    <div className="content-type-container">
        <ToggleButton
            name="content-type"
            id={`content-type-${ContentType.IMAGE}`}
            size="small"
            behavior="radio"
            value={ContentType.IMAGE}
            checked={currentContentType === `${ContentType.IMAGE}`}
            onChange={e => changeContentType(e.target.value)}
            iconName="image"
            title={`Show ${ContentType.IMAGE} only`}
        >
            Images
        </ToggleButton>
        <ToggleButton
            name="content-type"
            id={`content-type-${ContentType.VIDEO}`}
            size="small"
            behavior="radio"
            value={ContentType.VIDEO}
            checked={currentContentType === `${ContentType.VIDEO}`}
            onChange={e => changeContentType(e.target.value)}
            iconName="video"
            title={`Show ${ContentType.VIDEO} only`}
        >
            Videos
        </ToggleButton>
    </div>
);

ContentTypeSelector.propTypes = {
    changeContentType: PropTypes.func.isRequired,
    currentContentType: PropTypes.string.isRequired
};

export default ContentTypeSelector;



// WEBPACK FOOTER //
// ./campaign_analytics/v2/campaign_analytics_page/posts/posts_controls_row/content_type_selector.js